import { create } from 'zustand';
export const COMMENT_TASK_KEY = 'metanoia-selected-project-task';
export const COMMENT_UNAVAILABLE = 'That comment is no longer available.';
interface Target { projectId: string; taskId: string }
export const useCommentLanding = create<{ target: Target | null; unavailable: boolean; sequence: number }>(() => ({ target: null, unavailable: false, sequence: 0 }));
export function landOnComment(target: Target | null) {
  try {
    if (target) {
      localStorage.setItem('selectedProjectId', target.projectId);
      localStorage.setItem(COMMENT_TASK_KEY, JSON.stringify(target));
    } else {
      localStorage.removeItem('selectedProjectId');
      localStorage.removeItem(COMMENT_TASK_KEY);
    }
  } catch { /* Same-tab memory is authoritative when storage is blocked. */ }
  useCommentLanding.setState(s => ({ target, unavailable: !target, sequence: s.sequence + 1 }));
}
export function consumeCommentTarget(): Target | null {
  let target = useCommentLanding.getState().target;
  try {
    const raw = localStorage.getItem(COMMENT_TASK_KEY);
    localStorage.removeItem(COMMENT_TASK_KEY);
    if (!target && raw) {
      const value: unknown = JSON.parse(raw);
      if (value && typeof value === 'object' && 'projectId' in value && 'taskId' in value
        && typeof value.projectId === 'string' && typeof value.taskId === 'string') target = { projectId: value.projectId, taskId: value.taskId };
    }
  } catch { /* Invalid/stale storage must not prevent Projects opening. */ }
  useCommentLanding.setState({ target: null, unavailable: false });
  return target;
}
